import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetGroupListByPage(num, size, params) {
  return maintainRequest({
    url: `/device/maintenanceMan/device_group/getGroupListByAgentId/${num}/${size}`,
    params,
  });
}
